var map = {
	"./de/perceptions_descriptions": [
		"U7hp",
		51
	],
	"./en/perceptions_descriptions": [
		"zGH9",
		35
	],
	"./fr/perceptions_descriptions": [
		"60A5",
		19
	],
	"./nl/perceptions_descriptions": [
		"6iFv",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "cM/O";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/perceptions_descriptions$
// module id = cM/O
// module chunks = 97